var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAigenerate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_4069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3514 19.2698C9.43809 19.5505 8.45366 19.6508 7.44256 19.5327C3.95958 19.1262 1.36196 16.2631 1.17905 12.8767C1.17397 12.7802 1.17015 12.6824 1.16888 12.5846C1.18921 11.6077 1.36704 9.17017 2.54582 6.99426C2.31844 7.72719 2.39466 8.56173 2.67919 9.27814C3.20379 10.6017 4.24157 11.4236 5.3327 12.2111C6.17614 12.8208 7.04879 13.4102 7.74233 14.1939C9.01383 15.6331 9.93221 17.3936 10.3527 19.2698H10.3514Z",
    fill: "url(#paint0_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5035 13.2589C19.8109 14.1633 19.9391 15.1452 19.8502 16.1589C19.5428 19.652 16.7559 22.3309 13.3771 22.6117C13.2806 22.6205 13.1828 22.6269 13.0863 22.6294C12.1082 22.6371 9.66679 22.5304 7.45786 21.4151C8.19713 21.6209 9.02786 21.5218 9.73665 21.2169C11.0437 20.6555 11.8363 19.5936 12.5921 18.4809C13.1764 17.6209 13.7417 16.7305 14.5038 16.0153C15.9062 14.7032 17.64 13.734 19.5022 13.2589H19.5035Z",
    fill: "url(#paint1_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6185 4.82861C14.5305 4.54408 15.515 4.43992 16.5261 4.55424C20.0103 4.94674 22.6194 7.79968 22.8175 11.1848C22.8239 11.2814 22.8277 11.3792 22.8277 11.477C22.8112 12.4538 22.6435 14.8927 21.4736 17.0736C21.6972 16.3394 21.6184 15.5062 21.3314 14.7898C20.8017 13.4687 19.7601 12.6507 18.6664 11.867C17.8217 11.2611 16.9453 10.6755 16.2492 9.89429C14.9713 8.4602 14.0466 6.70347 13.6172 4.82861H13.6185Z",
    fill: "url(#paint2_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0165 19.2941C12.8421 19.7755 13.7516 20.0803 14.7627 20.1934C18.247 20.5859 21.4264 18.3871 22.3727 15.1315C22.3994 15.0388 22.426 14.9448 22.4476 14.8495C22.6496 13.893 23.3838 11.6879 22.3752 9.09155C22.4299 9.8575 22.1669 10.6514 21.7274 11.2865C20.917 12.4564 19.7192 13.0216 18.4782 13.5412C17.5191 13.9438 16.5347 14.3198 15.6811 14.9257C14.1162 16.0397 12.8498 17.5615 12.0152 19.2928L12.0165 19.2941Z",
    fill: "url(#paint3_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61244 10.6373C4.31774 9.72784 4.20342 8.74468 4.30758 7.73231C4.66579 4.24425 7.49078 1.60598 10.8734 1.37353C10.9699 1.36718 11.0678 1.3621 11.1656 1.35956C12.1436 1.36591 14.5825 1.50818 16.7762 2.65646C16.0394 2.44052 15.2074 2.52817 14.4948 2.82159C13.1789 3.36398 12.3723 4.41446 11.6 5.51575C11.003 6.36681 10.4263 7.24962 9.65272 7.95333C8.23133 9.24515 6.48476 10.1889 4.61498 10.6361L4.61244 10.6373Z",
    fill: "url(#paint4_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0599 12.1503C19.5324 11.3196 19.8614 10.3492 19.9656 9.33678C20.3225 5.84873 18.0907 2.6922 14.8262 1.7789C14.7335 1.75223 14.6382 1.7281 14.543 1.7065C13.584 1.5147 11.3725 0.802097 8.78629 1.83861C9.55096 1.77636 10.3487 2.03041 10.9876 2.46356C12.1664 3.26253 12.7431 4.45401 13.2766 5.68995C13.6881 6.64516 14.0743 7.62578 14.6891 8.47175C15.8183 10.0252 17.3197 11.3349 19.0599 12.1516V12.1503Z",
    fill: "url(#paint5_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0813 4.85016C11.2569 4.3662 10.2827 4.01943 9.27155 3.9013C5.78858 3.49355 2.60029 5.68089 1.64127 8.93268C1.61332 9.02541 1.58792 9.11941 1.56506 9.21467C1.35928 10.1699 0.616193 12.3725 1.6146 14.9726C1.56252 14.2067 1.82926 13.4128 2.2713 12.7815C3.08679 11.6154 4.28589 11.054 5.52945 10.5395C6.48974 10.1407 7.47671 9.76849 8.33158 9.1664C9.90159 8.06003 11.2404 6.58021 12.0838 4.85143L12.0813 4.85016Z",
    fill: "url(#paint6_linear_248_4069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02016 11.985C4.55907 12.8221 4.26057 13.7697 4.17165 14.7833C3.86425 18.2765 6.14178 21.4 9.42025 22.2663C9.51297 22.2917 9.60824 22.3145 9.70351 22.3348C10.6651 22.5127 12.8867 23.1923 15.4577 22.1202C14.6942 22.1939 13.8927 21.9512 13.2475 21.527C12.0572 20.7458 11.4628 19.5619 10.9128 18.3349C10.4872 17.386 10.0871 16.4105 9.45962 15.5734C8.30752 14.0364 6.77054 12.7776 5.01889 11.985H5.02016Z",
    fill: "url(#paint7_linear_248_4069)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_4069",
    x1: 1.96945,
    y1: 4.57483,
    x2: 5.76166,
    y2: 18.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4702D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250E83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_248_4069",
    x1: 13.0405,
    y1: 17.2983,
    x2: 19.1668,
    y2: 19.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4400CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_248_4069",
    x1: 20.5324,
    y1: 13.2617,
    x2: 18.1837,
    y2: 7.61931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1E0099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6C00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_248_4069",
    x1: 19.521,
    y1: 22.2622,
    x2: 19.521,
    y2: 7.1608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6C00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_248_4069",
    x1: 5.12561,
    y1: 5.81045,
    x2: 12.042,
    y2: 6.25503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4400CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_248_4069",
    x1: 12.7215,
    y1: 1.82463,
    x2: 20.0041,
    y2: 14.8514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.269069,
    stopColor: "#6C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_248_4069",
    x1: 1.10396,
    y1: 9.41156,
    x2: 13.5776,
    y2: 9.41156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#380085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#4E44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_248_4069",
    x1: 4.1437,
    y1: 17.3479,
    x2: 15.4577,
    y2: 17.3479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212285,
    stopColor: "#6C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_4069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7921,
    height: 21.4225,
    fill: "white",
    transform: "translate(1.10397 1.28876)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAigenerate);
export default __webpack_public_path__ + "static/media/aigenerate.f07543d4dbfbffe5b559c65fe2018dd6.svg";
export { ForwardRef as ReactComponent };